/* (ignored) */


//////////////////
// WEBPACK FOOTER
// buffer (ignored)
// module id = 815
// module chunks = 3